import {sagas, actions, reducer, selectors} from './model';
import {config} from './config';

export * from './types';

export {HelpText} from './HelpText'
export {WhereDoIGetDocText} from './WhereDoIGetDocText'

export const settingsModel = {
  actions,
  reducer,
  sagas,
  config,
  selectors,
};
